var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 9.33333C17.3333 10.0697 16.7364 10.6667 16 10.6667C15.2636 10.6667 14.6667 10.0697 14.6667 9.33333C14.6667 8.59695 15.2636 8 16 8C16.7364 8 17.3333 8.59695 17.3333 9.33333Z",
    fill: "#6391BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6667 13.3333C13.6667 12.7811 14.1144 12.3333 14.6667 12.3333H16C16.5523 12.3333 17 12.7811 17 13.3333V22.6667C17 23.219 16.5523 23.6667 16 23.6667C15.4477 23.6667 15 23.219 15 22.6667V14.3333H14.6667C14.1144 14.3333 13.6667 13.8856 13.6667 13.3333Z",
    fill: "#6391BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationI);
export default __webpack_public_path__ + "static/media/information-i.eeb2a066be0cbdf80cca92caf28fa884.svg";
export { ForwardRef as ReactComponent };